import axios from 'axios'
import {baseUrl} from '@/utils/evn'
import {Message} from 'element-ui'
import {getToken,removeToken} from '@/utils/cookies'
let msgBox = null;
//请求拦截
axios.interceptors.request.use(config => {
	config.baseURL = baseUrl;
	config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	config.headers = {
		 'x-dci-stoken': getToken('DCI_USER') ? JSON.parse(getToken('DCI_USER')).token : '',
	};
	return config;
}, (error) => {
	return Promise.reject(error);
});

//响应拦截
axios.interceptors.response.use((response) => {
	if (response.status && response.status === 200 && response.data.code === 200) {
		return response.data;
	}if( response.status && response.status === 200 && response.data.code === -5 ){
		msgBox = Message.error(response.data.message)
		removeToken('DCI_USER')
	} else{
		if (!msgBox) {
			msgBox = Message.error(response.data.message);
			msgBox.onClose = () => {
				msgBox = null;
			}
		}
	}
}, (error) => {
	if (error.response) {
		if (error.response.status === 9000) {
			Message('服务器升级中');
		} 
	}
	return Promise.resolve(error);
});

export default axios;